import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { uniqueId, isEmpty } from 'lodash-es'

import { Icon } from 'components'
import { fontWeights } from 'utils/fonts'

export interface InnerMenu {
  label: string
  id: string
  icon?: Array<string>
}

interface MainMenu {
  title: string
  innerMenus: Array<InnerMenu>
}

interface Props {
  menus: Array<MainMenu>
  onMenuClick?: (menu: InnerMenu) => void
}

const SideMenu: React.FC<Props> = ({ menus = [], onMenuClick = () => {} }) => {
  const { t } = useTranslation()

  const menuSection = (name: string): JSX.Element => <MenuSection key={uniqueId()}>{t(name)}</MenuSection>

  const innerSection = (innerMenu: InnerMenu): JSX.Element => (
    <InnerMenu key={uniqueId()} onClick={() => onMenuClick(innerMenu)}>
      {!isEmpty(innerMenu.icon) && <StyledIcon icon={innerMenu.icon} color="gray5" />}
      {t(innerMenu.label)}
    </InnerMenu>
  )

  const menuContent: Array<JSX.Element> = []

  menus.map((mainMenu: MainMenu) => {
    menuContent.push(menuSection(mainMenu.title))
    mainMenu.innerMenus.map((innerMenu: InnerMenu) => menuContent.push(innerSection(innerMenu)))
  })

  return !isEmpty(menuContent) ? <Container>{menuContent}</Container> : null
}

export default SideMenu

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.gray3};
`
const MenuSection = styled.div`
  background-color: ${({ theme }) => theme.colors.gray1};
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray3};
  font-size: 16px;
  font-weight: ${fontWeights.light};
  display: flex;
  align-items: center;
  padding: 15px;
`

const InnerMenu = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray2};
  font-size: 16px;
  font-weight: ${fontWeights.light};
  display: flex;
  align-items: center;
  padding: 15px;

  &:hover {
    cursor: pointer;
    background-color: ${({ theme }) => theme.colors.gray2};
  }
`

const StyledIcon = styled(Icon)`
  margin-right: 15px;
`
